import { useMemo } from 'react';
import { type IEmbedOuterGifImage } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function OuterGifImage ({ id }: IEmbedOuterGifImage) {
  const src = useMemo(() => id, [id]);

  if (!id) {
    return null;
  }

  return (
    <figure className={styles['outer-gif-image']}>
      <picture className={styles['outer-gif-image__picture']}>
        <img className={styles['outer-gif-image__img']} src={src} />
      </picture>
    </figure>
  );
}
